import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { supabase } from '../../../utils/supabase';
import PageLoader from '../../../microcomponents/PageLoader';


export const Route = createFileRoute('/_public/impersonate')({
  component: ImpersonateRoute
});

function ImpersonateRoute() {
  const navigate = useNavigate();

  useEffect(() => {
    async function handleImpersonation() {
      try {
        // Get impersonation data from URL hash
        const hash = window.location.hash.substring(1); // Remove the #
        const params = new URLSearchParams(hash);
        const impersonateData = params.get('impersonate');

        if (!impersonateData) {
          console.error('No impersonation data found in URL');
          alert('Invalid impersonation link');
          navigate({ to: '/login' });
          return;
        }

        // Decode the base64 data
        const decodedData = JSON.parse(atob(impersonateData));
        const { access_token, refresh_token, user } = decodedData;

        console.log('Setting impersonation session for:', user.email);

        // Set the Supabase session with the impersonation tokens
        const { data, error } = await supabase.auth.setSession({
          access_token,
          refresh_token
        });

        if (error) {
          console.error('Failed to set impersonation session:', error);
          alert('Failed to impersonate user. Session may be expired.');
          navigate({ to: '/login' });
          return;
        }

        console.log('Successfully set session for:', user.email);

        // Store impersonation flag in localStorage to show banner
        localStorage.setItem('isImpersonating', 'true');
        localStorage.setItem('impersonatedUser', JSON.stringify(user));

        // Clear the hash from URL for security
        window.history.replaceState(null, '', window.location.pathname);

        // Redirect to analytics/dashboard
        navigate({ to: '/analytics' });
      } catch (error) {
        console.error('Error during impersonation:', error);
        alert('Failed to impersonate user. Please try again.');
        navigate({ to: '/login' });
      }
    }

    handleImpersonation();
  }, [navigate]);

  return <PageLoader />;
}
